module.exports = __webpack_public_path__ + "static/media/03_BOJO_MEIA_TACA_LISO_09.c9042e3c.jpg";